module.exports = __webpack_public_path__ + "static/media/epipen-favicon.14396789.png";